export default __webpack_public_path__ + "static/media/logo-lg-1920w.34257618.png";